export class AlicuotaTipoBaseIIBB{
    tipoBaseImponibleIIBB: number;
    alicuotaIIBBCombustible: number;
    alicuotaIIBBDefecto: number;
    baseCalculoMinimoImponible: number;
    importeMinimoPercepcion: number;
}